import {GTMEcommerceOfferType} from "../types/GTMEcommerceOfferType";
import {OfferType} from "../types/OfferType";

export const gtmEcommerceOfferTypeMap: Record<OfferType, GTMEcommerceOfferType> = {
    [OfferType.HOUSE]: "Domy",
    [OfferType.FLAT]: "Mieszkania",
    [OfferType.COMMERCIAL]: "Lokale użytkowe",
    [OfferType.MODULAR_HOUSE]: "Domy modułowe"
};
import {GTMEcommerceOfferType} from "../types/GTMEcommerceOfferType";
import {OfferType} from "../types/OfferType";

export const gtmEcommerceOfferTypeMap: Record<OfferType, GTMEcommerceOfferType> = {
    [OfferType.HOUSE]: "Domy",
    [OfferType.FLAT]: "Mieszkania",
    [OfferType.COMMERCIAL]: "Lokale użytkowe",
    [OfferType.MODULAR_HOUSE]: "Domy modułowe"
};
